import { string, shape } from 'prop-types';
import { propTypes as linkPropTypes } from '../../01_atoms/Link';

export const PTQuickLinkItem = {
  title: string,
  image: shape({
    url: string,
    alt: string,
  }),
  link: shape({
    label: string.isRequired,
    nextLink: shape(linkPropTypes).isRequired,
  }),
  className: string,
};
